import { Spinner } from "react-bootstrap";
import NoData from "../../../../../components/NoData";
import TopicsClaimTable from "../../../../topics/components/TopicsClaimTable";
import { useTopicsClaims } from "../../../../topics/hook/useTopicsClaims";


export default function TopicClaims() {
    const { data: topics, isLoading: isTopicsLoading } = useTopicsClaims();

    return (<>
        {isTopicsLoading ? (
            <div className="overlay-spinner">
                <Spinner animation="border" variant="light" />
            </div>
        ) : topics ? (
           <TopicsClaimTable topics={topics} />
        ) : (
            <NoData />
        )}
    </>
    );
}
